<template>
	<div id="reportinfo">
        <HrrBreadcrumb PMname="岗位计划管理" CMname="单位基础信息管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="计划">
                        <el-select v-model="searchform.planId" value-key="planId" placeholder="请选择">
                            <el-option v-for="item in planIdData" :key="item.planId" :label="item.planName" :value="item.planId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="注册地址">
                        <el-input v-model="searchform.registerAddress" placeholder="注册地址"></el-input>
                    </el-form-item>
                    <el-form-item label="编制数">
                        <el-input v-model="searchform.planNum" placeholder="编制数"></el-input>
                        
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick()">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick()">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick()">删除</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="tableData" border stripe highlight-current-row style="width: 100%" @cell-click="cellclick" @selection-change="selectionchange">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <!--<el-table-column prop="postName" label="单位名称" width="150" fixed="left">
                    </el-table-column>-->
                    <el-table-column prop="propertyType" label="单位性质" width="150" fixed="left">
                    </el-table-column>
                    <el-table-column prop="registerAddress" label="注册地址" width="180">
                    </el-table-column>
                    <el-table-column prop="planNum" label="编制数" width="100">
                    </el-table-column>
                    <el-table-column prop="onjobNum" label="现有数" width="100">
                    </el-table-column>
                    <el-table-column prop="lackNum" label="缺编数" width="100">
                    </el-table-column>
                    <el-table-column prop="retireNum" label="年底拟退休人数" width="180">
                    </el-table-column>
                    <el-table-column prop="groupAddress" label="集体户登记住址" width="180">
                    </el-table-column>
                    <el-table-column prop="registerInstitution" label="集体户户口登记机关" width="180">
                    </el-table-column>
                    <el-table-column prop="linkman" label="联系人" width="180">
                    </el-table-column>
                    <el-table-column prop="phone" label="联系电话" width="180">
                    </el-table-column>
                    <el-table-column prop="linkAddress" label="通讯地址" width="180">
                    </el-table-column>
                    <el-table-column prop="postCode" label="邮政编码" width="180">
                    </el-table-column>
                    <el-table-column prop="publicInfo" label="发布招聘信息时公布的联系方式" width="180">
                    </el-table-column>
                    <el-table-column prop="mainWork" label="主营业务（主要职责）" width="180">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" >
                    </el-table-column>
                    <el-table-column label="操作" width="120" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
	</div>
</template>
<script>
    export default {
        name: 'plan_reportinfo',
        data() {
            return {
                searchform: {
                    pageNum: 1,
                    pageSize: 10,
                    postName: "",
                    postMajor:"",
                    planEdu:"",
                    planDiploma:"",
                    planId:""
                },
                tableData: [],
                planform: {
                    planId: ""
                },
                planIdData: [],
                total: 0,
                loading: true,
                selectionRows:[]
            }
        },
        methods: {
            onSubmit() {
                this.getReportInfoList();
            },
            handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
            Rowview(val) {
                const postid = val.oinfoId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/report/info/view/' + postid
                });
            },
            RowEdit(val) {
                const postid = val.oinfoId;
                this.$route.meta.row = val;
                this.$router.push({
                    path: '/plan/report/info/modify/' + postid
                });
            },
            Rowdelete(val){
				this.$confirm("确定要删除此记录么？","删除提示",{type:"warning"})
				.then(()=>{
                    var Vuethis=this;
                    // console.log(val)
					this.$hrraxios.post(this.$api.plan.reportInfoDel,{oinfoId:val.oinfoId})
					.then((response)=>{
						var redata=response.data;
						if(redata.success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
            Addclick() {
                this.$route.meta.row=this.tableData[this.tableData.length-1];
                this.$router.push({
                    path: '/plan/report/info/add',
                });
            },
            editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message.warning("只能操作一行记录");
					return;
				}
                this.$route.meta.row=this.selectionRows[0];
                // console.log(this.selectionRows[0])
				this.$router.push({path:'/plan/report/info/modify/'+this.selectionRows[0].oinfoId});
			},
            delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message.warning("请先选择一行记录");
					return;
				}
				this.$confirm("确定要删除？","删除提示",{type:"warning"}).then(()=>{
					var Vuethis=this;
					this.selectionRows.forEach(row=>{
						this.$hrraxios.post(this.$api.plan.reportInfoDel,{oinfoId:row.oinfoId})
						.then((response)=>{
							Vuethis.loading = false;
                            var data = response.data;
                            if (data.success == true) {
                                Vuethis.$message.success("已删除");
                                this.initData();
                            } else {
                                Vuethis.$message.error(data.prompt);
                            }
						})
						.catch((error)=>{
                            console.log(error);
						})
					});
				}).catch(()=>{

				});
			},
			cellclick(row, column, cell, event){
				this.$refs.tableData.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
            initData() {
                this.searchform.planId=this.planIdData[0].planId;
                this.getReportInfoList();
            },
            initParamsData(){
                this.$common.getplanlist(this,"planIdData",this.initData);
                this.$common.getStatus({forTable:"hrr_post"},"statusData",this);
            },
            getReportInfoList(){
                var Vuethis=this;
                this.$hrraxios.get(this.$api.plan.reportInfoList, {
                        params: this.searchform
                    })
                    .then(function(response) {
                        Vuethis.loading = false;
						var data = response.data;
                        if (data.success == true) {
							Vuethis.tableData = data.data.list;
                        } else {
                            Vuethis.$message.error(data.prompt);
                        }
                    })
                    .catch(function(error) {
                        Vuethis.loading = false;
                        console.log(error);
                    });
            },
        },

        beforeRouteLeave(to, from, next) {
            // 导航离开该组件的对应路由时调用
            to.meta.row = from.meta.row;
            next();
        },
        created() {
            this.initParamsData();
        }
    }
</script>
